var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      { name: "model", rawName: "v-model", value: _vm.val, expression: "val" }
    ],
    ref: "input",
    domProps: { value: _vm.val },
    on: {
      input: [
        function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.val = $event.target.value
        },
        function($event) {
          return _vm.updateValue($event.target.value)
        }
      ],
      change: _vm.emitChange
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2964abc9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2964abc9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/index.vue
// module id = 9
// module chunks = 0